import { render, staticRenderFns } from "./SalesTaxDocuments.vue?vue&type=template&id=6b7dd9a9&scoped=true&"
import script from "./SalesTaxDocuments.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SalesTaxDocuments.vue?vue&type=style&index=0&id=6b7dd9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7dd9a9",
  null
  
)

export default component.exports